module.exports = __webpack_public_path__ + "static/img/cert9.84bf2d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert9.png
// module id = 62VC
// module chunks = 52